import { color } from 'asserts/styles/colors';
import styled, { keyframes } from 'styled-components';

interface BannerProps {
  userInfo: UserInfor;
  companyInfo: CompanyInfor;
}

const Banner = ({ companyInfo, userInfo }: BannerProps) => {
  return (
    <Wrapper>
      <h3>반갑습니다. {companyInfo.companyname || userInfo.usrnickname || userInfo.usrname}님</h3>
      <h2>마이페이지</h2>
    </Wrapper>
  );
};

export default Banner;

const gradientMovement = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const Wrapper = styled.div`
  display: flex;
  padding: 64px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  background: ${color.gradientType1};
  border-radius: 24px;
  color: ${color.white};
  animation: ${gradientMovement} 3s linear infinite;
  background-size: 200% 100%;

  h2 {
    font-size: 44px;
    font-weight: 700;
    line-height: 48px;
  }

  h3 {
    font-size: 20px;
    line-height: 24px;
  }
`;
